var React = require('react');

function WhiteCheckGrid (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.707 3.293a1 1 0 0 1 0 1.414L7.5 20.914.293 13.707a1 1 0 1 1 1.414-1.414L7.5 18.086 22.293 3.293a1 1 0 0 1 1.414 0z","fill":"#fff","opacity":".5"}));
}

WhiteCheckGrid.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = WhiteCheckGrid;

WhiteCheckGrid.default = WhiteCheckGrid;
